import React, { useState, useEffect, useRef } from "react";
import useDidMountEffect from "../../customHooks/useDidMountEffect";
import { getCmDocsById } from "../../services/CmService";
import { downloadAdaMemberDocument, getAdaMemberDocumentsByParams, getAdaMemberDocumentsBySourceMenuID } from "../../services/ADAService";
import { getMasConfirmsById } from "../../services/MasConfirmsService";
import { useDispatch, useSelector } from "react-redux";
import { format } from 'date-fns'
import { useTranslation } from "react-i18next";
import {
  resetLettersReports,
  setCurrentActiveTab,
} from "../../state/actions/LettersReportsActions";
import { CmConstants } from "../../utils/constants/CmConstants";
import {
  TLUSHI_PENSION,
  LETTERS_REPORTS,
  PENSION_REPORTS,
  MAS_CONFIRMS,
  DOCS_101,
} from "../../utils/constants/LettersReportsConstants";
import TabsList from "../../components/Tabs/Tabs";
import RenderDocDetails from "../../components/RenderDocDetails/RenderDocDetails";
import RadioButtons from "../../components/RadioButtons/RadioButtons";
import HeDatePicker from "../../components/HeDatePicker/HeDatePicker";
import UserADADownloadDoc from "../../entities/UserADADownloadDoc";
import UserADADocs from "../../entities/UserADADocs";
import UserCmDoc from "../../entities/UserCMDoc";
import UserMasConfirm from "../../entities/UserMasConfirm";
import ErrorRender from "../../components/ErrorRender/ErrorRender";
import { GetDepositData } from "../../services/GetDepositData";
import DepositData from "../../entities/DepositData";
import CircleLoading from "../../components/CircleLoading/CircleLoading";
import { getFromDateValue } from "../../utils/helpers/dateFormatter";
import "./LettersAndReports.scss";
import { useRadioGroup } from "@mui/material";
import useWindowDimensions from "../../customHooks/useWindowDimensions";
import { screenSzie } from "../../utils/main";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import { useLocation } from "react-router-dom";
import ExpandedChip from "../../components/ExpandedChip/ExpandedChip";
import { getFundCode } from "../../utils/helpers/getFundCertificateNumber";
import UserFund from "../../entities/UserFund";


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const LettersAndReports = () => {
  const { t, i18n } = useTranslation("common");
  const location = useLocation<any>();
  const { width } = useWindowDimensions();
  const isMobile = (width < screenSzie.phone);
  const dispatch = useDispatch();
  const currentActiveTab = useSelector(
    (state: any) => state.LettersReportsReducer.currentActiveTab
  );
  const { userId, isAmit, isPensioner, haveMessages, userFunds } = useSelector(
    (state: any) => state.UserReducer
  );

  ///. setUserTlushiPension setUserCmReports setUserCmLetters
  const [userCmReports, setUserCmReports] = useState<UserCmDoc[]>([]);
  const [userCmReportsMemo, setUserCmReportsMemo] = useState<UserCmDoc[]>([]);
  const [userCmTlushiPension, setUserTlushiPension] = useState<UserCmDoc[]>([]);
  const [userCmTlushiPensionMemo, setUserTlushiPensionMemo] = useState<UserCmDoc[]>([]);
  const [userCmDocs101, setUserDocs101] = useState<UserCmDoc[]>([]);
  const [userCmDocs101Memo, setUserDocs101Memo] = useState<UserCmDoc[]>([]);
  const [userADADocs101Memo, setUserADADocs101Memo] = useState<UserADADocs[]>([]);
  const [userCmLetters, setUserCmLetters] = useState<UserCmDoc[]>([]);
  const [userCmLettersMemo, setUserCmLettersMemo] = useState<UserCmDoc[]>([]);
  const [userADADocsReports, setuserADADocsReports] = useState<UserADADocs[]>([]);
  const [userADADocsTlusheiPension, setuserADADocsTlusheiPension] = useState<UserADADocs[]>([]);
  const [userADADocsDocsAndLetters, setuserADADocsDocsAndLetters] = useState<UserADADocs[]>([]);
  const [userADADocs101, setUserADADocs101] = useState<UserADADocs[]>([]);
  const [userADADocs, setuserADADocs] = useState<UserADADocs[]>([]);
  const [UserADADownloadDoc, setUserADADownloadDoc] = useState<UserADADownloadDoc>();
  const [userDepositMessages, setDepositMessages] = useState<DepositData[]>([]);
  const [userMasConfirms, setUserMasConfirms] = useState<UserMasConfirm[]>([]);
  const [user101Docs, set101Docs] = useState<UserCmDoc[]>([]);
  const [radioValue, setRadioValue] = useState<string>(
    t("LettersReports.radioValue1")
  );
  const [startDateValue, setStartDateValue] = useState<Date | number | string>(
    getFromDateValue()
  );
  const [endDateValue, setEndDateValue] = useState<Date | number | string>(
    new Date()
  );
  const [loading, setLoading] = useState<Boolean>(false);
  const [insl, setInsl] = useState<Boolean>(false);
  const [dateError, setDateError] = useState<Boolean>(false);
  const [dateOpen, setdateOpen] = useState<Boolean>(false);
  const timer = useRef<any>(null);

  const [currentChip, setCurrentChip] = useState<number>(1);
  const [activeFundCode, setActiveFundCode] = useState<number | null>(Number.parseInt(sessionStorage.fundCode));
  const [currentFirstLabel, setFirstLabel] = useState<string>('');

  const [value, setValue] = React.useState(location.state?.tabVal || currentActiveTab || `${t("LettersReports.TabLabel1")}`);

  const handleChange = (event: any, newValue: string) => {
    setValue(newValue);
    dispatch(setCurrentActiveTab(newValue))
  };

  const datePickerIsDisabled = () =>
    radioValue === t("LettersReports.radioValue1");

  React.useEffect(() => {
    const setUserFunds = userFunds.filter((item: any) => { return Number(item.fundCode) == sessionStorage.fundCode })
    let clickedLabel = setUserFunds[0].fundLabel !== null && sessionStorage.fundCode ? `${setUserFunds[0].fundLabel}` : userFunds[0].fundLabel
    setFirstLabel(clickedLabel);
    heActiveFundCode(clickedLabel)
  }, [])

  useEffect(() => {
    document.title = "amitim " + t("LettersReports.lettersAndReports");
    return () => { };
  }, []);

  const getTabsLabelsByUserType = () => {
    if (isAmit && isPensioner) {
      return [
        t("LettersReports.TabLabel1"),
        t("LettersReports.TabLabel2"),
        t("LettersReports.TabLabel3"),
        t("LettersReports.TabLabel4"),
        t("LettersReports.TabLabel5"),
        t("LettersReports.TabLabel6"),
      ];
    } else if (isAmit) {
      return [
        t("LettersReports.TabLabel1"),
        t("LettersReports.TabLabel5"),
        t("LettersReports.TabLabel6"),
      ];
    } else if (isPensioner) {
      return [
        t("LettersReports.TabLabel1"),
        t("LettersReports.TabLabel2"),
        t("LettersReports.TabLabel3"),
        t("LettersReports.TabLabel4"),
        t("LettersReports.TabLabel5"),
        t("LettersReports.TabLabel6"),
      ];
    }
    return [];
  };
  // dynamic labels, depends on language and of type of user.
  // if user is gimlai - current tabLabels without tablabel6, else - tablabel 1,5,6
  const tabLabels: string[] = getTabsLabelsByUserType();

  const validateDatePickerValues = () => {
    // validate date picker values
    if (
      startDateValue &&
      startDateValue !== "" &&
      endDateValue &&
      endDateValue !== "" &&
      new Date(startDateValue) > new Date(endDateValue)
    ) {
      setDateError(true);
      setStartDateValue(getFromDateValue());
      setEndDateValue(new Date());
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        setDateError(false);
      }, 5000);
    }
  };

  const setDate = async () => {

    userCmLetters.length = 0;
    userCmReports.length = 0;
    userCmTlushiPension.length = 0;
    userCmDocs101.length = 0;
   

    if (userADADocsDocsAndLetters?.length > 0) {
      const userCmLetterscvar = []
      for (let i = 0; i < userADADocsDocsAndLetters.length; i++) {
        userCmLetterscvar.push({
          CmDocTypeID: userADADocsDocsAndLetters[i].docTypeID,
          DocDate: userADADocsDocsAndLetters[i].docDate.toString(),
          DocDisplayName: userADADocsDocsAndLetters[i].docDisplayName,
          FundCode: userADADocsDocsAndLetters[i].fundCode,
          PId: userADADocsDocsAndLetters[i].documentNum.toString(),
          docMedia: userADADocsDocsAndLetters[i].docMedia,
          memberID: userADADocsDocsAndLetters[i].memberID,
          scanCode: userADADocsDocsAndLetters[i].scanCode,
          ReportId: 0,
          Uri: "",
          YearDocDate: 0,

        })
      }
      setUserCmLetters(userCmLetterscvar)
      setUserCmLettersMemo(userCmLetterscvar)
    }
    const userCmReportsvar = []

    if (userADADocsReports?.length > 0) {
      for (let i = 0; i < userADADocsReports.length; i++) {
        userCmReportsvar.push({
          CmDocTypeID: userADADocsReports[i].docTypeID,
          DocDate: userADADocsReports[i].docDate.toString(),
          DocDisplayName: userADADocsReports[i].docDisplayName,
          FundCode: userADADocsReports[i].fundCode,
          PId: userADADocsReports[i].documentNum.toString(),
          docMedia: userADADocsReports[i].docMedia,
          memberID: userADADocsReports[i].memberID,
          scanCode: userADADocsReports[i].scanCode,
          ReportId: 0,
          Uri: "",
          YearDocDate: 0,

        })
      }
      setUserCmReports(userCmReportsvar)
      setUserCmReportsMemo(userCmReportsvar)
    }
    if (userADADocsTlusheiPension?.length > 0) {
      const userCmTlushiPensionvar = []
      for (let i = 0; i < userADADocsTlusheiPension.length; i++) {
        userCmTlushiPensionvar.push({
          CmDocTypeID: userADADocsTlusheiPension[i].docTypeID,
          DocDate: userADADocsTlusheiPension[i].docDate.toString(),
          DocDisplayName: userADADocsTlusheiPension[i].docDisplayName,
          FundCode: userADADocsTlusheiPension[i].fundCode,
          PId: userADADocsTlusheiPension[i].documentNum.toString(),
          docMedia: userADADocsTlusheiPension[i].docMedia,
          memberID: userADADocsTlusheiPension[i].memberID,
          scanCode: userADADocsTlusheiPension[i].scanCode,
          ReportId: 0,
          Uri: "",
          YearDocDate: 0,

        })
      }
      setUserTlushiPension(userCmTlushiPensionvar)
      setUserTlushiPensionMemo(userCmTlushiPensionvar)
    }

    if (userADADocs101?.length > 0) {
      const userCmDocs101var = []
      for (let i = 0; i < userADADocs101.length; i++) {
        userCmDocs101var.push({
          CmDocTypeID: userADADocs101[i].docTypeID,
          DocDate: userADADocs101[i].docDate.toString(),
          DocDisplayName: userADADocs101[i].docDisplayName,
          FundCode: userADADocs101[i].fundCode,
          PId: userADADocs101[i].documentNum.toString(),
          docMedia: userADADocs101[i].docMedia,
          memberID: userADADocs101[i].memberID,
          scanCode: userADADocs101[i].scanCode,
          ReportId: 0,
          Uri: "",
          YearDocDate: 0,

        })
      }
      setUserDocs101(userCmDocs101var)
      setUserDocs101Memo(userCmDocs101var)
    }
    
  }

  const setAda = async(results:any)=>{
    setuserADADocsReports(results[0]);
    setuserADADocsTlusheiPension(results[1]);
    setuserADADocsDocsAndLetters(results[2]);
    setUserADADocs101(results[3]);   
  }
 
  const setaLLDate = async()=>{
    setLoading(true);
    Promise.all([
      getAdaMemberDocumentsBySourceMenuID(sessionStorage.token.toUpperCase(), activeFundCode, format(new Date(startDateValue), 'yyyy-MM-dd'), CmConstants.Reports.SourceMenuId),
      getAdaMemberDocumentsBySourceMenuID(sessionStorage.token.toUpperCase(), activeFundCode, format(new Date(startDateValue), 'yyyy-MM-dd'), CmConstants.TlushiPension.SourceMenuId),
      getAdaMemberDocumentsBySourceMenuID(sessionStorage.token.toUpperCase(), activeFundCode, format(new Date(startDateValue), 'yyyy-MM-dd'), CmConstants.DocsAndLetters.SourceMenuId),
      getAdaMemberDocumentsBySourceMenuID(sessionStorage.token.toUpperCase(), activeFundCode, format(new Date(startDateValue), 'yyyy-MM-dd'), CmConstants.Doc101.SourceMenuId)      
    ]).then(async(results) => {      
       await setAda(results);
       setLoading(false);
      })
  }

  useEffect(()=>{
    setDate();
    setLoading(false);
  },[ userADADocsDocsAndLetters, userADADocsReports, userADADocsTlusheiPension, userADADocs101])

  const initAmitAndPensionerData = async (activeFundCode:number | null) => {
    setLoading(true);
    // haveMessages && setRadioValue(t("LettersReports.radioValue2"));
    const depositMessages = await GetDepositData( true , null ,null ,activeFundCode );
    Promise.all([
      getMasConfirmsById(),
    ]).then( (results) => {
       setDepositMessages(depositMessages);
       setUserMasConfirms(results[0]);
       setLoading(false);
    });
  };

  const setDepositData = async () => {
    setLoading(true);
    const depositMessages = await GetDepositData(true);
    Promise.all([
      getMasConfirmsById(),
    ]).then((results) => {
      setDepositMessages(depositMessages);
      setUserMasConfirms(results[0]);
      setLoading(false);
    });
  };

  useEffect(() => {
    !currentActiveTab.length &&
    dispatch(setCurrentActiveTab(t("LettersReports.TabLabel1")));
  }, [activeFundCode , startDateValue, endDateValue ]);

  useEffect(() => {
    const userFundsFilter =  userFunds.filter(
      (userFund: UserFund) => `00${activeFundCode}` === `${userFund.fundCode}`
      );
    let isAmitlist: any[] = [];
    if(userFundsFilter.length >= 2){
      isAmitlist =  userFundsFilter.filter((res:any)=>{
       return  res.isAmit ?? true 
      })
    }
    const activeFund = userFundsFilter[0];
    setLoading(false);
    setaLLDate();
    if ((activeFund?.isAmit || isAmitlist[0]?.isAmit )  ||  activeFundCode == null ) {
    initAmitAndPensionerData(activeFundCode);
    }else{
      setDepositMessages([]);
      setUserMasConfirms([]);
      setLoading(false);
    }
    setInsl(true)

    async function getUserCmDocs() {
    
    }
    getUserCmDocs();
    setStartDateValue(startDateValue)
  }, [activeFundCode , startDateValue ]);


  useEffect(() => {
    if(value == t("LettersReports.TabLabel6")){
      setDepositData()
    }
  }, [value ]);




  useEffect(() => {
    setRadioValue(t("LettersReports.radioValue1"));
  }, [i18n.language]);

  useEffect(() => {
    validateDatePickerValues();
  }, [dateOpen]);







  const heActiveFundCode = async (clickedLabel: string) => {
    if (clickedLabel !== currentFirstLabel) {
      const getactiveFundCode = await getFundCode(userFunds, clickedLabel);
      await setActiveFundCode(getactiveFundCode === 0 ? null : getactiveFundCode)
    }
  }

  const setFirstLabelf = (clickedLabel: any) => {
    setFirstLabel(clickedLabel)
    heActiveFundCode(clickedLabel);
    setEndDateValue(endDateValue)
  };




  const   newSetUserFunds:any =   new Set(userFunds.map((item: any) => { return item?.fundLabel }))
  let labeluserFunds = [t("deposits.firstChipLabel1"), ...newSetUserFunds]

  const handleChipClick = (chipIndex: number) => {
    setCurrentChip(chipIndex);
  };

  const isActiveChip = (chipIndex: number) => currentChip === chipIndex

  useEffect(() => {
    validateDatePickerValues();

  }, [startDateValue, endDateValue ]);


  

  useEffect(()=>{
    if(currentActiveTab){
      setValue(currentActiveTab || location.state?.tabVal)
    }
  },[currentActiveTab ,location.state?.tabVal])

  useEffect(() => {
    return () => {
      dispatch(setCurrentActiveTab(`${t('LettersReports.TabLabel1')}`))
    };
  }, []);



  const RenderCurrentTabDetails = () => {
    return (
    <>
      <TabPanel value={t('LettersReports.TabLabel1')} id={`tabpanel-${t('LettersReports.TabLabel1')}`} role="tabpanel" tab-index={"0"} aria-labelledby={`tab-${t('LettersReports.TabLabel1')}`}>
        <RenderDocDetails
          userADADownloadDoc={UserADADownloadDoc}
          userADADocs={userADADocs}
          key={LETTERS_REPORTS}
          userCmReports={userCmLetters}
          userDepositsMessages={userDepositMessages}
          renderLabel={LETTERS_REPORTS}
          radioValue={radioValue}
          setRadioValue={setRadioValue}
          startDateValue={startDateValue}
          setStartDateValue={setStartDateValue}
          endDateValue={endDateValue}
          setEndDateValue={setEndDateValue}
        />
      </TabPanel>
      <TabPanel value={t('LettersReports.TabLabel2')} id={`tabpanel-${t('LettersReports.TabLabel2')}`} role="tabpanel" tab-index={"0"} aria-labelledby={`tab-${t('LettersReports.TabLabel2')}`}>
        <RenderDocDetails
          userADADownloadDoc={UserADADownloadDoc}
          userADADocs={userADADocs}
          key={TLUSHI_PENSION}
          userCmReports={userCmTlushiPension}
          renderLabel={TLUSHI_PENSION}
          radioValue={radioValue}
          setRadioValue={setRadioValue}
          startDateValue={startDateValue}
          setStartDateValue={setStartDateValue}
          endDateValue={endDateValue}
          setEndDateValue={setEndDateValue}
        />
      </TabPanel>
      <TabPanel value={t('LettersReports.TabLabel3')} id={`tabpanel-${t('LettersReports.TabLabel3')}`} role="tabpanel" tab-index={"0"} aria-labelledby={`tab-${t('LettersReports.TabLabel3')}`}>
        <RenderDocDetails
          userADADownloadDoc={UserADADownloadDoc}
          userADADocs={userADADocs}
          key={DOCS_101}
          userCmReports={userCmDocs101}
          renderLabel={DOCS_101}
          radioValue={radioValue}
          setRadioValue={setRadioValue}
          startDateValue={startDateValue}
          setStartDateValue={setStartDateValue}
          endDateValue={endDateValue}
          setEndDateValue={setEndDateValue}
        />
      </TabPanel>
      <TabPanel value={t('LettersReports.TabLabel4')} id={`tabpanel-${t('LettersReports.TabLabel4')}`} role="tabpanel" tab-index={"0"} aria-labelledby={`tab-${t('LettersReports.TabLabel4')}`}>
        <RenderDocDetails
          userADADownloadDoc={UserADADownloadDoc}
          userADADocs={userADADocs}
          key={TLUSHI_PENSION}
          userCmReports={userCmTlushiPension}
          renderLabel={TLUSHI_PENSION}
          from106Docs={true}
          radioValue={radioValue}
          setRadioValue={setRadioValue}
          startDateValue={startDateValue}
          setStartDateValue={setStartDateValue}
          endDateValue={endDateValue}
          setEndDateValue={setEndDateValue}
        />
      </TabPanel>
      <TabPanel value={t('LettersReports.TabLabel5')} id={`tabpanel-${t('LettersReports.TabLabel5')}`} role="tabpanel" tab-index={"0"} aria-labelledby={`tab-${t('LettersReports.TabLabel5')}`}>
        <RenderDocDetails
          userADADownloadDoc={UserADADownloadDoc}
          userADADocs={userADADocs}
          key={PENSION_REPORTS}
          userCmReports={userCmReports}
          renderLabel={PENSION_REPORTS}
          radioValue={radioValue}
          setRadioValue={setRadioValue}
          startDateValue={startDateValue}
          setStartDateValue={setStartDateValue}
          endDateValue={endDateValue}
          setEndDateValue={setEndDateValue}
        />
      </TabPanel>
      <TabPanel value={t('LettersReports.TabLabel6')} id={`tabpanel-${t('LettersReports.TabLabel6')}`} role="tabpanel" tab-index={"0"} aria-labelledby={`tab-${t('LettersReports.TabLabel6')}`}>
      {/* <CustomTabPanel value={5} index={5}> */}
        <RenderDocDetails
          userADADownloadDoc={UserADADownloadDoc}
          userADADocs={userADADocs}
          key={MAS_CONFIRMS}
          userCmReports={userMasConfirms}
          renderLabel={MAS_CONFIRMS}
          radioValue={radioValue}
          setRadioValue={setRadioValue}
          startDateValue={startDateValue}
          setStartDateValue={setStartDateValue}
          endDateValue={endDateValue}
          setEndDateValue={setEndDateValue}
        />
      {/* </CustomTabPanel> */}
      </TabPanel>
    </>
    )


  };
 

  return (
    <div className="reports-container page letters-reports">
      <main id="main" className="content">
        <div className="he-pg-ca">
          {dateError && (
            <ErrorRender
              headerLabel={t("ErrorRender.dateHeaderLabel")}
              label={t("ErrorRender.dateLabel")}
              margin="15px 10px"
            />
          )}
          <h1>{t("LettersReports.lettersAndReports")}</h1>
        </div>
        {!isMobile ?
          <div id="letters-reports-wrap-details" className="wrap-details desktop">
            <TabContext  value={value} >
            {/* value={currentActiveTab} */}
              <TabsList
                labels={tabLabels}
                currentActiveTab={currentActiveTab}
                setCurrentActiveTab={setCurrentActiveTab}
                setVal={location.state?.tabVal}
                handleChange={handleChange}
              />

              <>

                <div className="letters-reports-mobile-wrapper">
                  {value !== t("LettersReports.TabLabel6") ? (
                    <div className="d-flex align-items-center margin-reports-datepicker">
                      <ExpandedChip
                        label={currentFirstLabel}
                        setCurrentLabel={(clickedLabel) => setFirstLabelf(clickedLabel)}
                        iconLabel={"ArrowDown"}
                        labels={labeluserFunds}
                        boxRight={"7px"}
                        boxWidth={"180px"}
                        index={1}
                        handleChipClick={handleChipClick}
                        isActiveChip={isActiveChip}
                      />
                      <RadioButtons
                        setRadioValue={setRadioValue}
                        radioValue={radioValue}
                        firstRadioTString="LettersReports.radioValue1"
                        secondRadioTString="LettersReports.radioValue2"
                      />
                      <HeDatePicker
                        dateLabel={t("general.fromDate")}
                        dateValue={startDateValue}
                        setDateValue={setStartDateValue}
                        isDisabled={datePickerIsDisabled}
                        isOpenFun={() => validateDatePickerValues}
                        maxDate={endDateValue}
                      />
                      <HeDatePicker
                        minDate={startDateValue}
                        dateLabel={t("general.toDate")}
                        dateValue={endDateValue}
                        setDateValue={setEndDateValue}
                        isDisabled={datePickerIsDisabled}
                        isOpenFun={() => validateDatePickerValues}
                      />
                    </div>
                  ) : null}

                  {loading ? (
                    <CircleLoading />
                  ) : (

                    RenderCurrentTabDetails()

                  )}
                </div>
              </>
            </TabContext>
          </div>
          :
          <div className="wrap-details mobile">
            <TabContext value={value}>
              <div className="wrap-tabs">
                <TabsList
                  labels={tabLabels}
                  currentActiveTab={currentActiveTab}
                  setCurrentActiveTab={setCurrentActiveTab}
                  setVal={location.state?.tabVal}
                  handleChange={handleChange}
                />
              </div>
              {loading ? (
                <CircleLoading />
              ) : (
                <>
                  <div className="letters-reports-mobile-wrapper">
                    {value !== t("LettersReports.TabLabel6") ? (
                      <div className="wrap-radio-btn">
                        <ExpandedChip
                          label={currentFirstLabel}
                          setCurrentLabel={(clickedLabel) => setFirstLabelf(clickedLabel)}
                          iconLabel={"ArrowDown"}
                          labels={labeluserFunds}
                          boxRight={"7px"}
                          boxWidth={"180px"}
                          index={1}
                          handleChipClick={handleChipClick}
                          isActiveChip={isActiveChip}
                        />
                        <RadioButtons
                          setRadioValue={setRadioValue}
                          radioValue={radioValue}
                          firstRadioTString="LettersReports.radioValue1"
                          secondRadioTString="LettersReports.radioValue2"
                          mobileRender={true}
                        />
                        <div className="wrap-date-picker-mobile">
                          <HeDatePicker
                            dateLabel={t("general.fromDateMobile")}
                            dateValue={startDateValue}
                            setDateValue={setStartDateValue}
                            isDisabled={datePickerIsDisabled}
                            isOpenFun={() => validateDatePickerValues}
                          />

                          <HeDatePicker
                            dateLabel={t("general.toDateMobile")}
                            dateValue={endDateValue}
                            setDateValue={setEndDateValue}
                            isDisabled={datePickerIsDisabled}
                            isOpenFun={() => validateDatePickerValues}
                          />
                        </div>
                      </div>
                    ) : null}
                    {RenderCurrentTabDetails()}
                  </div>
                </>
              )}
            </TabContext>
          </div>
        }
      </main>
    </div>
  );
};

export default LettersAndReports;
